import { ref, watch } from 'vue';
import { E_RM_ACTION } from '@/types';
import { useI18n } from 'vue-i18n';

export function useGraphTool() {
    const { t } = useI18n();
    let reLocate = () => {};
    let zoomOut = () => {};
    let zoomIn = () => {};
    let zoomTo100 = () => {};
    const zoom = ref(1);
    const formattedZoom = ref([
        {
            icon: 'SolidRefresh',
            action: () => reLocate(),
            name: t(`graphTool.${[E_RM_ACTION.RE_LOCATE]}`),
        },
        // { icon: 'SolidZoomInBoard', action: () => reLocate(), name: E_RM_ACTION.RE_LOCATE },
        {
            icon: 'SolidZoomOut',
            action: () => zoomOut(),
            name: t(`graphTool.${[E_RM_ACTION.ZOOM_OUT]}`),
        },
        {
            icon: 'SolidZoomIn',
            action: () => zoomIn(),
            name: t(`graphTool.${[E_RM_ACTION.ZOOM_IN]}`),
        },
        {
            icon: '',
            width: 48,
            text: `${Math.ceil(zoom.value * 100)}%`,
            action: () => zoomTo100(),
            name: t(`graphTool.${[E_RM_ACTION.ZOOM_100]}`),
        }
    ]);
    function handleVisualReady(visual: any) {
        const graphTool = visual?.graphTool;
        // reLayout = () => {
        //     graphTool.reLayout?.();
        //     zoom.value = visual.chart?.getZoom() || 1
        // }
        reLocate = () => {
            graphTool.reLocate?.();
            zoom.value = visual.chart?.getZoom() || 1;
        };
        zoomTo100 = () => {
            graphTool.zoomTo100?.();
            zoom.value = visual.chart?.getZoom() || 1;
        };
        zoomIn = () => {
            graphTool.zoomIn?.();
            zoom.value = visual.chart?.getZoom() || 1;
        };
        zoomOut = () => {
            graphTool.zoomOut?.();
            zoom.value = visual.chart?.getZoom() || 1;
        };

        visual?.chart && visual?.chart.on('wheelzoom', () => {
            zoom.value = visual.chart?.getZoom() || 1;
        });

        setTimeout(() => {
            graphTool && reLocate()
        }, 2000)
    }
    watch(() => zoom.value, (val) => {
        formattedZoom.value[3].text = `${Math.ceil(val * 100)}%`;
    });
    return {
        handleVisualReady,
        formattedZoom,
    };
}
